import { FeatureFlags } from '@insurer-frontend/client-feature-flags';
import type { LDClient } from 'launchdarkly-js-client-sdk';
import { toLegacySurePartPath } from './surepart-routing';

const mceSurePartUser1AccountId = '1326508698';
const testInsurerMitchellCompanyId = '1110356042';

export const isIFESmokeTestAccount = (user: { principal_accountid?: string; companyid?: string } | null): boolean =>
    user?.principal_accountid === mceSurePartUser1AccountId && user.companyid === testInsurerMitchellCompanyId;

export const enableStaffEstimatingRollback = (
    client: Pick<LDClient, 'variationDetail' | 'on'>,
    isIFESmokeTestAccountUser = false,
): void => {
    const rollbackIfDisabled = (): void => {
        if (isIFESmokeTestAccountUser) {
            return;
        }
        const detail = client.variationDetail(
            FeatureFlags.releaseSurePartAllowInsurerFrontend.key,
            false,
        );
        if (
            detail.value === false &&
            detail.variationIndex !== null &&
            detail.variationIndex !== undefined
        ) {
            // oxlint-disable-next-line unicorn/no-document-cookie
            document.cookie =
                '__Host-pt-surepart-ui=staffestimating; Max-Age=3600; Path=/; Secure; SameSite=Lax';
            const legacyPathname = toLegacySurePartPath(globalThis.location.pathname);
            if (legacyPathname === globalThis.location.pathname) {
                globalThis.location.reload();
                return;
            }

            globalThis.location.href = `${legacyPathname}${globalThis.location.search}${globalThis.location.hash}`;
        }
    };

    rollbackIfDisabled();
    client.on(`change:${FeatureFlags.releaseSurePartAllowInsurerFrontend.key}`, rollbackIfDisabled);
};
